const styles = theme => ({
paragraph: {
  color: 'rgb(51, 51, 51)', 
  fontFamily: 'Gilroy-Light',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '22.4px',
  marginBottom: '10px',
  textAlign: 'left'
},
  sectionHeading: {
    color: 'rgb(51, 51, 51)',
    fontFamily: 'Gilroy-Light',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px',
    marginTop: '24px',
    marginBottom: '12px',
    textAlign: 'left'
  },
  h6: {
    fontSize: '1.75rem',
    margin: '15px 0px'
  },
  h5: {
    fontSize: '2rem',
    fontWeight: 'bolder',
    margin: '15px 0px'
  },
  h4: {
    fontSize: '2.5rem',
    fontWeight: 'bolder'
  }

});

export default styles;
